import { parent } from '.';

export const getData = (key: string) => {
  parent.postMessage({ playdeck: { method: 'getData', key } }, '*');
};
